import orderBy from "lodash/orderBy";
import { StudentNavReflectionFragment } from "../StudentNavigation.generated";

export default function sortReflections(
  reflections: Array<StudentNavReflectionFragment | null>,
) {
  return orderBy(
    reflections,
    [
      // Reflections with unread teacher replies come first.
      "hasNotifications",
      // Unanswered reflections come before answered ones.
      "isCompleted",
      // Finally, sort by creation/publish date.
      (reflection) => {
        if (reflection) {
          return reflection.messages.length
            ? reflection.messages.slice(-1)[0].createdAt
            : reflection.session.publishedAt;
        }
      },
    ],
    [
      "desc", // hasNotifications
      "asc", // isCompleted
      "desc", // createdAt/publishedAt
    ],
  );
}
